import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Col, Grid, Icon, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import GridSpinner from 'components/UI/GridSpinner'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { INIT_2FA } from 'modules/User/Security/2fa/types'
import styles from 'modules/User/Security/Security.module.scss'
import clsx from 'clsx'

const QrCode = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [code, setCode] = useState(null)
  const breakpoints = useBreakpoint()

  useEffect(() => {
    setLoading(true)
    new Promise((resolve, reject) => {
      dispatch({ type: INIT_2FA, meta: { resolve, reject } })
    })
      .then((data) => {
        setCode(data)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  return (
    <>
      <div className={'margin-bottom-40'}>
        <Typography
          variant={'Subtitle-25'}
          noMargin
          className={'margin-bottom-16'}
          component={'div'}
        >
          {t('user::security.2fa.enable_form.steps.two')}
        </Typography>

        <Grid
          gap={16}
          cols={!breakpoints.md ? 1 : 2}
          className={'margin-bottom-16'}
          direction={!breakpoints.md ? 'column' : 'row'}
        >
          <Col>
            <Button
              variant={'primary'}
              fullWidth
              size={'m'}
              component={'a'}
              grey
              target={'_blank'}
              rel={'noopener noreferrer'}
              href={'https://apps.apple.com/app/google-authenticator/id388497605'}
              startIcon={
                <Icon
                  name={'apple'}
                  size={'m'}
                />
              }
            >
              {t('user::security.ios_app')}
            </Button>
          </Col>
          <Col>
            <Button
              variant={'primary'}
              fullWidth
              size={'m'}
              component={'a'}
              grey
              target={'_blank'}
              rel={'noopener noreferrer'}
              href={
                'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
              }
              startIcon={
                <Icon
                  name={'android'}
                  size={'m'}
                />
              }
            >
              {t('user::security.android_app')}
            </Button>
          </Col>
        </Grid>

        <Typography
          variant={'Body-20'}
          color={'Label-Secondary'}
          component={'div'}
        >
          {t('user::security.2fa.enable_form.summary')}
        </Typography>
      </div>

      <Typography
        variant={'Subtitle-25'}
        className={'margin-bottom-16'}
        component={'div'}
      >
        {t('user::security.2fa.enable_form.steps.three')}
      </Typography>

      <Typography
        variant={'Body-20'}
        className={'margin-bottom-16'}
        color={'Label-Secondary'}
        component={'div'}
        dangerouslySetInnerHTML={{ __html: t('user::security.2fa.header') }}
      />

      <Grid
        justifyContent={'center'}
        className={clsx(styles['security__qr-block'], 'margin-bottom-16')}
      >
        {loading || !code ? (
          <GridSpinner />
        ) : (
          <img
            src={code.qr_code}
            alt={''}
          />
        )}
      </Grid>

      {code && (
        <>
          <Typography
            variant={'Body-20'}
            color={'Label-Secondary'}
            component={'div'}
          >
            <p
              style={{ wordWrap: 'break-word' }}
              dangerouslySetInnerHTML={{
                __html: t('user::security.2fa.description_1', {
                  secret: code.secret.replace(/(.{4})/g, '$1 '),
                }),
              }}
            />
          </Typography>
          <Typography
            variant={'Body-20'}
            noMargin
            color={'Label-Secondary'}
            component={'div'}
          >
            {t('user::security.2fa.description_2')}
          </Typography>
        </>
      )}
    </>
  )
}

QrCode.propTypes = {
  setShowDisconnectionForm: PropTypes.func,
  qr_code: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
}

export default QrCode
